export default __webpack_public_path__ + "static/media/abayomi.c6ef8a1c.webp";